import { IConfigsType } from '../../types'

const mwbBonusTracker: IConfigsType = {
  mwb: {
    '/:brand/ops_scorecard': {
      groupFilter: {
        api: 'corporateWithoutBreakdownFilter',
      },
      dateFilter: {
        types: ['quarter'],
        startDate: '2025-03-29',
      },
      title: {
        type: 'title',
        title: 'Ops Scorecard',
      },
      aiBlackbox: {
        type: 'ai-blackbox-wrapper',
        contentPartNames: ['expoMwbBonusTracker'],
        hasDateFilter: true,
        hasGroupFilter: true,
      },
    },
  },
}

export default mwbBonusTracker
